import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class CategoryMenus extends Component {
	
	constructor(){
		super()
		this.state = {
			open: 		false,
			cat: 		false,
			maxHeight: 	0,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
		
	  	window.addEventListener('resize', this.handleResize);
	}
	componentDidUpdate(){ 
		if (this.state.cat !== this.props.post.title) {
			this.setState({ open : false, cat : this.props.post.title, maxHeight : 0});
			window.addEventListener('resize', this.handleResize);
		}
	}
	 	
	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false, cat : this.props.post.title });
	    } else {
		    this.setState({ open : true, cat : this.props.post.title });
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
        
    handleResize() {
	  	if (this.accordionBody && this.state.open === true) {
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
	  	
	render () {
		
		let post = this.props.post;
										
	    return (
	
		    <div className="c-page__block c-page__block--inset c-page__block--load-effect">
				
				<div className="l-grid">
		    
		    		<div className="l-grid__col">
		    		
						<nav className="c-projects__terms">
							{post.categories.map((category,i) =>
								{
									if (category.active === true) {
										return (
											<Link to={{ pathname: category.url }} className="c-projects__terms__link c-projects__terms__link--active" dangerouslySetInnerHTML={ {__html:category.name}} key={i}></Link>
										)
									} else {
										return (
											<Link to={{ pathname: category.url }} className="c-projects__terms__link" dangerouslySetInnerHTML={ {__html:category.name}} key={i}></Link>
										)
									}
								}
							)}
						</nav>
						<div className={'c-projects__mobile-nav ' + (this.state.open ? 'state-open' : "")}>
							<a href="#" onClick={this.handleToggle} className="c-projects__mobile-nav__text" dangerouslySetInnerHTML={ {__html:'Filter <span>> ' + post.title + '</span>'}}></a>
							<div className="c-projects__mobile-nav__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
								<div className="c-projects__mobile-nav__body__inner" ref={e => (this.accordionBodyInner = e)}>
									<nav className="c-projects__mobile-nav__nav">
										{post.categories.map((category,i) =>
											{
												if (category.active === true) {
													return null
												} else {
													return (
														<Link to={{ pathname: category.url }} className="c-projects__mobile-nav__link" dangerouslySetInnerHTML={ {__html:category.name}} key={i}></Link>
													)
												}
											}
										)}
									</nav>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
